var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListViewActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16638_5130)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.25743 38.699C7.44733 38.6995 6.65558 38.9403 5.98231 39.3909C5.30905 39.8414 4.7845 40.4815 4.47501 41.2301C4.16551 41.9788 4.08497 42.8024 4.24357 43.5968C4.40216 44.3913 4.79278 45.1208 5.36601 45.6933C5.93924 46.2657 6.66934 46.6553 7.46399 46.8128C8.25864 46.9703 9.08215 46.8886 9.83037 46.578C10.5786 46.2675 11.2179 45.7421 11.6675 45.0682C12.1171 44.3943 12.3568 43.6022 12.3563 42.7921C12.354 41.7062 11.9212 40.6656 11.1529 39.8983C10.3845 39.131 9.34329 38.6997 8.25743 38.699V38.699Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.258 23.4149C7.31127 23.4161 6.39422 23.7454 5.66303 24.3468C4.93184 24.9482 4.43173 25.7844 4.24786 26.7131C4.064 27.6418 4.20775 28.6055 4.65465 29.4402C5.10154 30.2748 5.82394 30.9287 6.69881 31.2905C7.57367 31.6523 8.54691 31.6996 9.45277 31.4244C10.3586 31.1493 11.1411 30.5686 11.6669 29.7813C12.1927 28.994 12.4293 28.0488 12.3364 27.1066C12.2436 26.1644 11.827 25.2836 11.1577 24.6141C10.3882 23.8458 9.34529 23.4145 8.258 23.4149V23.4149Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25731 8.13049C7.17061 8.13049 6.12842 8.56218 5.36001 9.33059C4.5916 10.099 4.15991 11.1412 4.15991 12.2279C4.15991 13.3146 4.5916 14.3568 5.36001 15.1252C6.12842 15.8936 7.17061 16.3253 8.25731 16.3253V16.3253C9.34401 16.3253 10.3862 15.8936 11.1546 15.1252C11.923 14.3568 12.3547 13.3146 12.3547 12.2279C12.3547 11.1412 11.923 10.099 11.1546 9.33059C10.3862 8.56218 9.34401 8.13049 8.25731 8.13049V8.13049Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.012 9.41113H18.4517C16.8896 9.41113 15.6233 10.6768 15.6233 12.2382C15.6233 13.7995 16.8896 15.0652 18.4517 15.0652H49.012C50.5741 15.0652 51.8405 13.7995 51.8405 12.2382C51.8405 10.6768 50.5741 9.41113 49.012 9.41113Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.012 24.6838H18.4517C16.8896 24.6838 15.6233 25.9495 15.6233 27.5109C15.6233 29.0722 16.8896 30.3379 18.4517 30.3379H49.012C50.5741 30.3379 51.8405 29.0722 51.8405 27.5109C51.8405 25.9495 50.5741 24.6838 49.012 24.6838Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0149 39.9799H18.4489C16.8884 39.9799 15.6233 41.2449 15.6233 42.8055C15.6233 44.366 16.8884 45.631 18.4489 45.631H49.0149C50.5754 45.631 51.8405 44.366 51.8405 42.8055C51.8405 41.2449 50.5754 39.9799 49.0149 39.9799Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16638_5130"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(0 0.669678)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListViewActive);
export default __webpack_public_path__ + "static/media/list-view-active.7f2b2b7b23065ec8291049a986302341.svg";
export { ForwardRef as ReactComponent };